import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.values";
import _typeof from "/app/node_modules/@babel/runtime-corejs2/helpers/typeof";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.split";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { preparedLocales } from "./modules/language";
import wModal from "./components/W-Modal/";
import Cookies from 'js-cookie';
import { API_REQUEST } from '@/api/';
export default {
  name: 'App',
  components: {
    wModal: wModal
  },
  data: function data() {
    return {
      chosenLocale: preparedLocales[0],
      locales: preparedLocales,
      modalName: '',
      init: false
    };
  },
  watch: {
    appLoading: function appLoading(value) {
      switch (value) {
        case true:
          this.$q.loading.show({
            delay: 400 // ms

          });
          break;

        case false:
          this.$q.loading.hide();
          break;
      }
    },
    '$route': {
      immediate: true,
      handler: function handler(newRoute) {
        if (this.init) this.checkAllowedPage();
        this.$store.commit('queryMirrored/handleRouteChanges', {
          newRoute: newRoute
        });
      }
    },
    '$store.state.application.primaryPageLoaded': function $storeStateApplicationPrimaryPageLoaded(value) {
      if (value === true) {
        console.log('MM primary page loaded');

        if (this.embedMode === true) {
          window.parent.postMessage({
            source: 'mm-embed',
            type: 'readyToShow'
          }, '*');
          console.log('"readyToShow" event fired.');
        }
      }
    }
  },
  methods: {
    checkAllowedPage: function checkAllowedPage() {
      var _this$$store$state$ap;

      this.fixDepsQueryParams();
      var spliter = this.$route.path.split('/');
      var pathCurrent = spliter.length > 1 ? spliter[1] : '';
      var menu = this.$i18n.messages[this.$i18n.locale].menu;
      var menuItem = menu.find(function (item) {
        return item.path.replace('/', '') === pathCurrent;
      });
      var allowedTabs = ((_this$$store$state$ap = this.$store.state.application) === null || _this$$store$state$ap === void 0 ? void 0 : _this$$store$state$ap.allowedTabs) || [];

      if (menuItem && !allowedTabs.includes(menuItem.allowedTab)) {
        var menuItem1 = menu.find(function (item) {
          return item.allowedTab === allowedTabs[0];
        });
        if (!menuItem1 || !menuItem1.path) return;
        this.$router.push({
          path: menuItem1.path,
          query: _objectSpread({}, this.$route.query)
        });
      }
    },
    handleParentWindow: function handleParentWindow(currentLayout) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve) {
                  if (currentLayout !== 'Main') {
                    // 'Login' or false
                    if (_this.embedMode === true) {
                      window.parent.postMessage({
                        source: 'mm-embed',
                        type: 'authRequired',
                        csrfToken: Cookies.get('csrftoken')
                      }, '*');
                      console.log('"Auth required" message fired.');
                      window.addEventListener('message', /*#__PURE__*/function () {
                        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ev) {
                          var userInfoAnswer, sessionOk;
                          return _regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  if (!(ev.data.type === 'auth')) {
                                    _context.next = 11;
                                    break;
                                  }

                                  console.log('parent "auth" event catched (with "sessionId").');
                                  Cookies.set('sessionid', ev.data.sessionId, {
                                    secure: true,
                                    sameSite: 'None'
                                  });
                                  _context.next = 5;
                                  return API_REQUEST('getUserInfo');

                                case 5:
                                  userInfoAnswer = _context.sent;
                                  sessionOk = !!userInfoAnswer[1];

                                  _this.$store.commit('application/setLoading', {
                                    value: false
                                  });

                                  console.log('is signed in to M&M:', sessionOk);
                                  if (sessionOk) _this.$store.commit('application/setLayout', {
                                    value: 'Main'
                                  });
                                  resolve();

                                case 11:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        }));

                        return function (_x) {
                          return _ref.apply(this, arguments);
                        };
                      }(), false);
                    } else {
                      resolve();
                    }
                  } else {
                    resolve();
                  }
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    fixDepsQueryParams: function fixDepsQueryParams() {
      var query = this.$route.query;

      if (query.deps) {
        var newQuery = _objectSpread(_objectSpread({}, query), {}, {
          deps: query.deps.split(',').filter(function (el) {
            return el;
          }).join()
        });

        this.$router.push({
          query: newQuery
        }).catch(function () {});
      }
    },
    parseErrorMessage: function parseErrorMessage(error) {
      var _error$response, _error$response2;

      var data = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data;
      var errorStr;

      if ((error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) in this.i18n.errors.status) {
        // explicit error message is defined in i18n
        // 500, 502, 504 ... - standard error messages
        errorStr = this.i18n.errors.status[error.response.status];
      } else if (data) {
        // all other messages
        // 400, 401, 403 ... - message should be in response
        errorStr = data.error || data.message || data.detail || data.result || data;
      }

      switch (_typeof(errorStr)) {
        case 'string':
          return errorStr;

        case 'object':
          if (Array.isArray(errorStr)) return errorStr.join('\n'); // Flattens { key1: [str1, str2], key2: [str3] } to newline separated string.
          // TODO: Django rest framework validations comes back as Object with many
          // keys, that contain Arrays of Strings. Show them better.

          try {
            return Object.values(errorStr).map(function (v) {
              return v.join('\n');
            }).join('\n');
          } catch (error) {
            return JSON.stringify(data);
          }

        case 'undefined':
          return '';

        default:
          return JSON.stringify(data);
      }
    }
  },
  computed: {
    appLoading: function appLoading() {
      return this.$store.state.application.loading;
    },
    embedMode: function embedMode() {
      return this.$store.state.application.embedMode;
    },
    routerViewReady: function routerViewReady() {
      return !!this.$store.state.application.layout;
    },
    i18n: function i18n() {
      return {
        errors: this.$t('errors')
      };
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var modalResult, currentLayout;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(window.location !== window.parent.location)) {
                _context3.next = 5;
                break;
              }

              // embedMode
              _this2.$store.dispatch('application/changeLocale', 'ru-ru');

              localStorage.setItem('locale', 'ru-ru');
              _context3.next = 13;
              break;

            case 5:
              if (localStorage.getItem('locale')) {
                _context3.next = 12;
                break;
              }

              _context3.next = 8;
              return _this2.$refs.languageModal.start();

            case 8:
              modalResult = _context3.sent;

              if (modalResult === 'ok') {
                _this2.$store.dispatch('application/changeLocale', _this2.chosenLocale.value);

                localStorage.setItem('locale', _this2.chosenLocale.value);
              }

              _context3.next = 13;
              break;

            case 12:
              _this2.$store.dispatch('application/changeLocale', localStorage.getItem('locale'));

            case 13:
              document.addEventListener('apiRequestError', function (event) {
                var error = event.detail.error;

                var errorStr = _this2.parseErrorMessage(error);

                _this2.$q.dialog({
                  title: _this2.$t('mainTerms.error'),
                  message: errorStr
                });
              });

              if (process.env.DEV) {
                document.addEventListener('keydown', function (event) {
                  if (event.key === 'F2') {
                    _this2.$store.dispatch('application/changeLocale', _this2.$i18n.locale === 'ru-ru' ? 'en-us' : 'ru-ru');

                    localStorage.setItem('locale', _this2.$i18n.locale);
                  }
                });
              }

              _context3.next = 17;
              return _this2.$store.dispatch('application/initialize', {});

            case 17:
              currentLayout = _this2.$store.state.application.layout;
              _context3.next = 20;
              return _this2.handleParentWindow(currentLayout);

            case 20:
              _this2.checkAllowedPage();

              _this2.init = true;

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};